import React, { RefObject } from "react";

interface VideoProps {
  videoSrc: { video: { src: string; breakpoint: number }[] };
  videoRef: RefObject<HTMLVideoElement>;
}

const Video: React.FC<VideoProps> = ({ videoSrc, videoRef }) => (
  <video loop playsInline autoPlay muted ref={videoRef} data-testid='banner-video'>
    {videoSrc.video.map((video) => (
      <source
        key={video.breakpoint}
        src={video.src}
        media={`(min-width: ${video.breakpoint}px)`}
        type='video/mp4'
      />
    ))}
  </video>
);

export default Video;
